import * as React from 'react'
import { Button } from '../../primitives/button'
import { DateRange } from 'react-day-picker'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../primitives/popover'
import { Calendar } from './calendar'

export type DatePickerProps = {
  selection: DateRange | undefined
  handleSelection: (d: DateRange | undefined) => void
  children: React.ReactNode
  align?: 'start' | 'end'
}

export function DatePickerWithRange({
  selection,
  handleSelection,
  children,
  align,
}: DatePickerProps) {
  const currentDate = React.useMemo(() => new Date(), [])
  const previousMonth = React.useMemo(() => {
    const date = new Date()
    date.setMonth(date.getMonth() - 1)
    return date
  }, [])
  const [month, setMonth] = React.useState<Date>(previousMonth)

  const disabledMatcher = React.useCallback(
    (d: Date) => d > currentDate,
    [currentDate]
  )

  return (
    <Popover modal>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent className="w-auto !p-0" align={align}>
        <Calendar
          mode="range"
          selected={selection ?? undefined}
          onSelect={handleSelection}
          month={month}
          onMonthChange={setMonth}
          disabled={disabledMatcher}
          endMonth={currentDate}
          numberOfMonths={2}
          classNames={{
            months: 'flex px-3 pb-2 gap-x-6',
          }}
          footer={
            <div className="flex gap-x-3 border-t border-dark-border-solid pt-3 px-4">
              <Button
                unstyled
                focusStyled
                className="text-dark-control-base hover:text-dark-control-highlight transition-colors cursor-default font-medium text-xs"
                onClick={() => handleSelection(undefined)}
              >
                Clear
              </Button>
              <Button
                unstyled
                focusStyled
                className="text-dark-faint hover:text-dark-dim transition-colors cursor-default font-medium text-xs"
                onClick={() => setMonth(previousMonth)}
              >
                Today
              </Button>
            </div>
          }
        />
      </PopoverContent>
    </Popover>
  )
}
